module.exports = __webpack_public_path__ + "static/media/mega.d7b814ed.jpg";